import React, { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import darimLogo from '../assets/images/darimlogo.jpeg';

const Navbar = () => {
  const [isScrolled, setIsScrolled] = useState(false);
  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);

  useEffect(() => {
    const handleScroll = () => {
      setIsScrolled(window.scrollY > 50);
    };

    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  const toggleMobileMenu = () => {
    setIsMobileMenuOpen(!isMobileMenuOpen);
  };

  return (
    <nav className={`fixed top-0 left-0 right-0 z-50 transition-all duration-300 ${isScrolled ? 'bg-white/95 backdrop-blur-md shadow-md py-2' : 'bg-white/90 backdrop-blur-sm py-4'}`}>
      <div className="container mx-auto px-4">
        <div className="flex items-center justify-between">
          {/* Logo */}
          <Link to="/" className="flex items-center gap-3 group">
            <img 
              src={darimLogo} 
              alt="DARIM NGO Logo" 
              className="h-10 w-auto group-hover:scale-110 transition-transform duration-300"
            />
            <span className="text-2xl font-bold font-heading bg-gradient-to-r from-primary to-primary-light bg-clip-text text-transparent">Darim NGO</span>
          </Link>

          {/* Desktop Navigation */}
          <ul className="hidden md:flex items-center gap-8">
            {[
              { name: 'Home', path: '/' },
              { name: 'About Us', path: '/about' },
              { name: 'Our Work', path: '/programs' },
              { name: 'Impact', path: '/impact' },
              { name: 'Contact', path: '/contact' },
            ].map((link, index) => (
              <li key={index}>
                <Link
                  to={link.path}
                  className="text-gray-700 font-medium hover:text-primary relative py-2 after:content-[''] after:absolute after:bottom-0 after:left-0 after:w-0 after:h-0.5 after:bg-gradient-to-r after:from-primary after:to-primary-light after:transition-all after:duration-300 hover:after:w-full"
                >
                  {link.name}
                </Link>
              </li>
            ))}
          </ul>

          {/* CTA Button */}
          <div className="hidden md:flex items-center">
            <Link to="/donate" className="px-6 py-2.5 bg-gradient-to-r from-primary to-primary-light text-white rounded-full font-bold shadow-md hover:-translate-y-0.5 hover:shadow-lg transition-all duration-300">
              Donate Now
            </Link>
          </div>

          {/* Mobile Menu Toggle */}
          <button
            className="md:hidden flex flex-col gap-1.5 p-2 z-50"
            onClick={toggleMobileMenu}
            aria-label="Toggle menu"
          >
            <span className={`w-6 h-0.5 bg-primary rounded-full transition-all duration-300 ${isMobileMenuOpen ? 'rotate-45 translate-y-2' : ''}`}></span>
            <span className={`w-6 h-0.5 bg-primary rounded-full transition-all duration-300 ${isMobileMenuOpen ? 'opacity-0' : ''}`}></span>
            <span className={`w-6 h-0.5 bg-primary rounded-full transition-all duration-300 ${isMobileMenuOpen ? '-rotate-45 -translate-y-2' : ''}`}></span>
          </button>
        </div>

        {/* Mobile Menu */}
        <div className={`fixed inset-0 bg-white z-40 flex flex-col pt-24 px-6 h-screen w-screen overflow-y-auto transition-transform duration-300 md:hidden ${isMobileMenuOpen ? 'translate-x-0' : '-translate-x-full'}`}>
          <ul className="flex flex-col gap-6 text-center">
            {[
              { name: 'Home', path: '/' },
              { name: 'About Us', path: '/about' },
              { name: 'Our Work', path: '/programs' },
              { name: 'Impact', path: '/impact' },
              { name: 'Contact', path: '/contact' },
            ].map((link, index) => (
              <li key={index}>
                <Link
                  to={link.path}
                  onClick={toggleMobileMenu}
                  className="block text-xl font-medium text-gray-800 hover:text-primary hover:bg-gray-50 py-2 rounded-lg transition-colors"
                >
                  {link.name}
                </Link>
              </li>
            ))}
            <li>
              <Link
                to="/donate"
                onClick={toggleMobileMenu}
                className="block w-full py-3 bg-gradient-to-r from-primary to-primary-light text-white rounded-full text-lg font-bold shadow-md"
              >
                Donate Now
              </Link>
            </li>
          </ul>
        </div>
      </div>
    </nav>
  );
};

export default Navbar;
